
import { db } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';

export const UpdateService = {
    /**
     * Subscribes to the global system metadata for update broadcasts.
     * Character-for-character match from useUpdateEngine.ts
     */
    listenToUpdaterMetadata(callback: (data: any) => void) {
        return onSnapshot(doc(db, 'system', 'metadata'), (snap) => {
            if (snap.exists()) {
                callback(snap.data());
            }
        });
    }
};
